import { gql } from '@apollo/client'

export default {
  getWikiLinks: () => gql`
    query getWikiLinks($placeIds: [ID]) {
      wikiLinks(placeIds: $placeIds) {
        title
        description
        url
      }
    }
  `,
}
